__turbopack_context__.v({
  "attentionIcon": "rpbkMW_attentionIcon",
  "errorContainer": "rpbkMW_errorContainer",
  "errorText": "rpbkMW_errorText",
  "optionsContainer": "rpbkMW_optionsContainer",
  "optionsGrid": "rpbkMW_optionsGrid",
  "standardAspect": "rpbkMW_standardAspect",
  "title": "rpbkMW_title",
  "wideAspect": "rpbkMW_wideAspect",
});
